import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'amountInput',
    'amountText',
    'feesText',
    'totalText',
    'radioPaymentByCard',
  ];
  static values = {
    isMember: Boolean,
    feesPercentage: Number,
    maxCardAmount: Number,
  };

  connect() {
    this.updateCalculation();
  }

  updateCalculation() {
    const amount = parseFloat(this.amountInputTarget.value);
    const fees = this.isMemberValue ? 0 : amount * 0.05;
    const total = amount + fees;

    this.toggleCardPaymentAvailability(total);

    if (isNaN(total)) return;

    this.amountTextTarget.textContent = this.convertToCurrency(amount);
    this.feesTextTarget.textContent = this.convertToCurrency(fees);
    this.totalTextTarget.textContent = this.convertToCurrency(total);
  }

  toggleCardPaymentAvailability(amount) {
    const input = this.radioPaymentByCardTarget.querySelector('input');

    if (!isNaN(amount) && amount > this.maxCardAmountValue) {
      this.radioPaymentByCardTarget.classList.add('d-none');
      input.checked = false;
      input.disabled = true;
    } else {
      this.radioPaymentByCardTarget.classList.remove('d-none');
      input.disabled = false;
    }
  }

  convertToCurrency(value) {
    return parseFloat(value).toLocaleString('fr-FR', {
      style: 'currency',
      currency: 'EUR',
    });
  }
}
